import { render, staticRenderFns } from "./ChangeLang.vue?vue&type=template&id=3953ae84&scoped=true&"
import script from "./ChangeLang.vue?vue&type=script&lang=js&"
export * from "./ChangeLang.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLang.vue?vue&type=style&index=0&id=3953ae84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3953ae84",
  null
  
)

export default component.exports